import { Box, Typography, styled } from "@mui/material";
export const contactSx = {
  main: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mt: -5
  },
  emailField: {
    mt: "6px"
  },
  numberField: {
    mt: "6px"
  },
  submitBox: {
    pt: {
      xs: 3, sm: 1
    },
    mt: 3
  },
  submitButton: {
    width: "150px"
  }
}
export const MainBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  border: "1px solid black",
  borderRadius: "50px",
  width: "400px",
  height: "500px",
  backgroundColor: "white",
  paddingBottom: 5,
  pt: 2,
  [theme.breakpoints.down("md")]: {
    height: "500px",
    width: "350px",
  },
}));
export const AuthButton = styled("button")(({ theme }) => ({
  borderRadius: "30px",
  border: "none",
  fontFamily: "Inter, sans-serif",
  fontWeight: 800,
  position: "relative",
  height: "41px",
  width: "200px",

  [theme.breakpoints.down("md")]: {
    fontSize: "16px",
    marginBottom: theme.spacing(1),
  },
}));

export const Heading = styled(Typography)(({ theme }) => ({
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(5),
  color: theme.palette.primary.main,
  fontSize: "36px",
  [theme.breakpoints.down("md")]: {
    paddingBottom: theme.spacing(3),
  },
}));

export const FormBox = styled(Box)(({ theme }) => ({
  width: "100%",
  minHeight: "200px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  [theme.breakpoints.down("md")]: {},
}));

export const ModalBackgroundBox = styled(Box)(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  backdropFilter: "blur(5px)",
  zIndex: 1,
  [theme.breakpoints.down("md")]: {},
}));
